import { takeLatest, call, put, all } from "redux-saga/effects";

import { firestoreService } from "../../firebase/firebase.service";
import {
  fetchInstagramPostsSuccess,
  fetchInstagramPostsFailure,
} from "./instagram.actions";
import InstagramActionTypes from "./instagram.types";

const POST_COUNT = 10;

export function* fetchInstagramPostsAsync() {
  try {
    const posts = yield call(
      [firestoreService, firestoreService.getLatestInstagramPosts],
      POST_COUNT,
    );
    yield put(fetchInstagramPostsSuccess(posts.length ? posts : null));
  } catch (err) {
    yield put(fetchInstagramPostsFailure(err.message));
  }
}

export function* fetchInstagramPostsStart() {
  yield takeLatest(
    InstagramActionTypes.FETCH_INSTAGRAM_POSTS_START,
    fetchInstagramPostsAsync,
  );
}

export function* instagramSagas() {
  yield all([call(fetchInstagramPostsStart)]);
}
